
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/customer-data-management-integration",
      function () {
        return require("private-next-pages/use-cases/customer-data-management-integration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/customer-data-management-integration"])
      });
    }
  